import { enqueueSnackbar } from "notistack";
import SnackbarConfig from "../../../utils/snackbarConfig";
import {
  INVOICES_LIST_FAILURE,
  INVOICES_LIST_REQUEST,
  INVOICES_LIST_SUCCESS,
  PAYMENT_LIST_FAILURE,
  PAYMENT_LIST_REQUEST,
  PAYMENT_LIST_SUCCESS,
} from "../constants";
import apiConfig from "../../../services/apiManager/apiConfig";
import {
  getInvoiceDetailsRequest,
  getInvoiceListRequest,
  getPaymentDetailsRequest,
  getPaymentDocumentRequest,
  getpaymentListRequest,
} from "../../../services/apiManager/apiRequests";
import { substituteUrlParams } from "../../../services/apiManager/helper";

export const getInvoiceList =
  (custId, params, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: INVOICES_LIST_REQUEST,
        payload: { isLoading: true },
      });
      let inVoiceParams = {
        start: 0,
        rows: 1000,
        wt: "json",
        fq: `doc_type:charges&fq=primary_reference_type_code:RESERVATION_ID&fq=charge_status_code:(BILLED PAID)`,
      };
      // current sort method is charge_created_date so below code is commented ....
      // if (params.sort) {
      //     inVoiceParams = { ...inVoiceParams, sort: `due_amount ${params.sort}` }
      // }

      if (params.sort) {
        inVoiceParams = {
          ...inVoiceParams,
          sort: `charge_created_date ${params.sort}`,
        };
      }

      if (params?.q) {
        inVoiceParams = { ...inVoiceParams, q: params.q };
      }

      const response = await getInvoiceListRequest(
        `${apiConfig.paymentInvoice.invoices}`,
        inVoiceParams,
      );
      if (response) {
        dispatch({
          type: INVOICES_LIST_SUCCESS,
          payload: response.response.docs,
        });
        callback(response);
      } else {
        dispatch({
          type: INVOICES_LIST_FAILURE,
          payload: {},
        });
        callback({});
        enqueueSnackbar("Error fetching Invoice List", {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
      }
    } catch (error) {
      enqueueSnackbar("Error fetching Invoice List", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback({});
      dispatch({
        type: INVOICES_LIST_FAILURE,
        payload: [],
      });
    }
  };

export const getPaymentList =
  (custId, params, callback = () => {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: PAYMENT_LIST_REQUEST,
        payload: { isLoading: true },
      });

      let paymentsParams = {
        start: 0,
        rows: 1000,
        wt: "json",
        fq: `primary_reference_type_code:RESERVATION_ID`,
      };

      if (params.sort) {
        paymentsParams = {
          ...paymentsParams,
          sort: `payment_date ${params.sort}`,
        };
      }

      if (params.q) {
        paymentsParams = { ...paymentsParams, q: params.q };
      }

      const response = await getpaymentListRequest(
        `${apiConfig.paymentInvoice.payments}`,
        paymentsParams,
      );
      if (response) {
        dispatch({
          type: PAYMENT_LIST_SUCCESS,
          payload: response.response.docs,
        });
        callback(response);
      } else {
        dispatch({
          type: PAYMENT_LIST_FAILURE,
          payload: {},
        });
        callback({});
        enqueueSnackbar("Error fetching Payment List", {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
      }
    } catch (error) {
      enqueueSnackbar("Error fetching Payment List", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback({});
      dispatch({
        type: PAYMENT_LIST_FAILURE,
        payload: [],
      });
    }
  };

export const getInvoiceDetails =
  (billNumber, customerId, callback = () => {}) =>
  async (dispatch) => {
    try {
      const apiChargesUrl = substituteUrlParams(
        apiConfig.paymentInvoice.invoiceChargeDetails,
        { billNumber },
      );

      const apiBillHistoryUrl = substituteUrlParams(
        apiConfig.paymentInvoice.billpaymentHistory,
        { billNumber },
      );

      const getCustomerAddress = substituteUrlParams(
        apiConfig.paymentInvoice.customerDetails,
        { customerId },
      );

      const allYardAddress = apiConfig.paymentInvoice.locations;

      const chargesResponse = await getInvoiceDetailsRequest(
        apiChargesUrl,
        null,
      );

      const billHistoryResponse = await getInvoiceDetailsRequest(
        apiBillHistoryUrl,
        null,
      );

      const customerAddressResponse = await getInvoiceDetailsRequest(
        getCustomerAddress,
        null,
      );

      const allYardsResponse = await getInvoiceDetailsRequest(
        allYardAddress,
        null,
      );

      if (chargesResponse && billHistoryResponse) {
        callback({
          chargesResponse,
          billHistoryResponse,
          customerAddressResponse,
          allYardsResponse: allYardsResponse.response.docs,
        });
      } else {
        callback({});
        enqueueSnackbar("Error fetching Invoice Details", {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
      }
    } catch (error) {
      enqueueSnackbar("Error fetching Invoice Details", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback({});
    }
  };

export const getPaymentDetails =
  (billNumber, params, callback = () => {}) =>
  async (dispatch) => {
    try {
      const apiUrl = substituteUrlParams(
        apiConfig.paymentInvoice.paymentHistory,
        { billNumber },
      );
      let param = {
        paymentVersion: params?.paymentVersion,
      };
      if (params?.paymentCode === "REFUNDIN") {
        param["paymentTypeCd"] = params?.paymentCode;
      }

      const response = await getPaymentDetailsRequest(apiUrl, param);
      if (response) {
        callback(response);
      } else {
        callback({});
        enqueueSnackbar("Error fetching Invoice Details", {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
      }
    } catch (error) {
      enqueueSnackbar("Error fetching Invoice Details", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback({});
    }
  };

export const getPaymentDocumentUrl =
  (billNumber, params, isInvoice, callback = () => {}) =>
  async (dispatch) => {
    try {
      const apiUrl = substituteUrlParams(
        isInvoice
          ? apiConfig.paymentInvoice.invoiceDocumentUrl
          : apiConfig.paymentInvoice.paymentDocumentUrl,
        { billNumber },
      );

      let param = {
        paymentVersion: params?.paymentVersion,
      };
      if (params?.paymentCode === "REFUNDIN") {
        param["paymentTypeCd"] = params?.paymentCode;
      }
      const response = await getPaymentDocumentRequest(apiUrl, params);
      if (response) {
        return response;
      } else {
        callback({});
        enqueueSnackbar("Error fetching payment PDF.", {
          variant: "error",
          autoHideDuration: 3000,
          action: SnackbarConfig,
        });
      }
    } catch (error) {
      enqueueSnackbar("Error fetching payment PDF", {
        variant: "error",
        autoHideDuration: 3000,
        action: SnackbarConfig,
      });
      callback({});
    }
  };
